import React from "react";
import {
  Alert,
  Form,
  Icon,
  Input,
  Button,
  Select,
  Row,
  Col,
  Steps,
  Transfer,
  Checkbox,
} from "antd";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";
import printJS from "print-js";

import {
  transferDrugRequest,
  transferDrugConfirmRequest,
} from "../../api/requests";
import {
  getDrugAllowTransferFromFridgeToPatient,
  getDrugShipmentAmount,
  getDrugTransferBalanceDrugs,
  getDrugChooseOrderByPermission,
} from "../../reducers/user/selectors";

import classes from "./DrugShipForm.css";
import { logout } from "../../reducers/user/actions";
import uniq from "lodash/uniq";
import { withNamespaces } from "react-i18next";

const { Option } = Select;
const { Step } = Steps;

class DrugShipForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      currentStep: 0,
      drugTransferList: [],
      drugTransferTargetKeys: [],
      drug_transfer_list: {},
      shiftDown: false,
    };
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          if (this.state.currentStep === 0) {
            const { data } = await transferDrugRequest({
              total_vials: values.total_vials,
              drug_order_by: values.drug_order_by,
              overwrite_balancing_drugs_shipment:
                values.overwrite_balancing_drugs_shipment,
              from_location_id: values.from_location_id,
              location_id: values.location_id,
            });
            this.setState({
              isLoading: false,
              requestResult: {
                type: "success",
                message: this.props.i18n.t("Success"),
              },
              drugTransferList: data.map((vial) => ({
                key: vial.id,
                title: vial.vial_number,
                description: vial.vial_number,
                chosen: false,
              })),
            });

            setTimeout(() => {
              this.setState({ requestResult: {}, currentStep: 1 });
            }, 1000);
          }

          if (this.state.currentStep === 1) {
            const { data } = await transferDrugConfirmRequest({
              drug_ids: this.state.drugTransferTargetKeys,
              from_location_id: values.from_location_id,
              location_id: values.location_id,
            });
            this.setState({
              isLoading: false,
              drug_transfer_list: data.drug_transfer_list,
              currentStep: 2,
              requestResult: {
                type: "success",
                message: this.props.i18n.t("Success"),
              },
            });

            setTimeout(() => {
              this.props.onSubmit();
            }, 1000);
          }
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onDrugPrintRequest = (dataJSON) => async () => {
    const from_location = get(dataJSON, "from_location.name");
    const to_location = get(dataJSON, "to_location.name");
    const vial_records = get(dataJSON, "vial_records");
    const total_vials = get(dataJSON, "total_vials");

    console.log("printing ....");
    printJS({
      printable: vial_records,
      properties: [{ field: "vial_number", displayName: this.props.i18n.t("Drug #") }],
      type: "json",
      header: `<h3 class="custom-h3">` + this.props.i18n.t('NamespaceDrugShipForm:From Location:') + `${from_location} <br/> ` + this.props.i18n.t('NamespaceDrugShipForm:To Location:') + ` ${to_location} <br/> ` + this.props.i18n.t('NamespaceDrugShipForm:Number of drugs:') + ` ${total_vials}</h3>`,
      style: ".custom-h3 { color: red; }",
    });
    return false;
  };

  handleTransferChange = (targetName) => (targetKeys) => {
    this.setState({ [targetName]: targetKeys });
  };

  onFromChange = (value) => {
    this.props.form.setFieldsValue({ location_id: null });
    this.props.onFromChange(value);
  };

  onTargetKeyChange = (index, key) => (e) => {
    const isChecked = e.target.checked;
    const { drugTransferTargetKeys, drugTransferList, shiftDown } = this.state;
    if (drugTransferTargetKeys.length && shiftDown) {
      const lastCheckedItemIndex = drugTransferList.findIndex(
        (item) =>
          item.key === drugTransferTargetKeys[drugTransferTargetKeys.length - 1]
      );

      let newItems = [];

      if (lastCheckedItemIndex < index) {
        newItems = drugTransferList.reduce((result, item, itemIndex) => {
          return itemIndex > lastCheckedItemIndex && itemIndex <= index
            ? [...result, item.key]
            : result;
        }, []);
      } else {
        newItems = drugTransferList.reduce((result, item, itemIndex) => {
          return itemIndex < lastCheckedItemIndex && itemIndex >= index
            ? [...result, item.key]
            : result;
        }, []);
      }

      this.setState(({ drugTransferTargetKeys }) => ({
        drugTransferTargetKeys: uniq([...drugTransferTargetKeys, ...newItems]),
      }));
    } else {
      this.setState(({ drugTransferTargetKeys }) => ({
        drugTransferTargetKeys: isChecked
          ? uniq([...drugTransferTargetKeys, key])
          : uniq(drugTransferTargetKeys.filter((item) => item !== key)),
      }));
    }
  };

  render() {
    const {
      isLoading,
      requestResult,
      currentStep,
      drugTransferList,
      drugTransferTargetKeys,
      drug_transfer_list,
    } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { sitesListFrom, sitesListTo, drugChooseOrderByPermission } = this.props;

    const orderByOptions = [
      {"value": null, "label": "--"},
      {"value": "id", "label": this.props.i18n.t("By id")},
      {"value": "expiry_date", "label": this.props.i18n.t("NamespaceDrugShipForm:By expire date")},
    ]

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t("NamespaceDrugShipForm:Ship drugs")}
          </h4>

          <Steps current={currentStep} style={{ marginBottom: "20px" }}>
            <Step
              title={this.props.i18n.t("Step 1")}
              description={this.props.i18n.t(
                "NamespaceDrugShipForm:Transfer drugs"
              )}
            />
            <Step
              title={this.props.i18n.t("Step 2")}
              description={this.props.i18n.t("NamespaceDrugShipForm:Confirm")}
            />
            <Step
              title={this.props.i18n.t("Step 3")}
              description={this.props.i18n.t(
                "NamespaceDrugShipForm:Print packing slip"
              )}
            />
          </Steps>

          <Row
            gutter={12}
            style={{ display: currentStep === 0 ? "block" : "none" }}
          >
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t("NamespaceDrugShipForm:From Storage")}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("from_location_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select")}
                      onChange={this.onFromChange}
                    >
                      {map(sitesListFrom, ({ value, label }) => (
                        <Option
                          key={value}
                          value={value}
                          disabled={value === getFieldValue("location_id")}
                        >
                          {label}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t("NamespaceDrugShipForm:To Storage")}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("location_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select")}
                      disabled={this.props.siteListLoading}
                    >
                      {map(sitesListTo, ({ value, label }) => (
                        <Option
                          key={value}
                          value={value}
                          disabled={value === getFieldValue("from_location_id")}
                        >
                          {label}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceDrugShipForm:Total drug packages"
                  )}{" "}
                  <span style={{ color: "#f00" }}>*</span>
                </b>
                <Form.Item>
                  {getFieldDecorator("total_vials", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: this.props.drugShipmentAmount || 6,
                  })(<Input />)}
                </Form.Item>
              </label>
            </Col>

            {drugChooseOrderByPermission && (
              <Col span={12}>
                <b>{this.props.i18n.t("Order by")}{" "}</b>
                <Form.Item>
                  <div>
                    {getFieldDecorator("drug_order_by", {
                      initialValue: null,
                      valuePropName: "checked",
                    })(
                      <Select placeholder={this.props.i18n.t("Select")}>
                        {map(orderByOptions, ({value, label}) => (
                          <Option
                            key={value}
                            value={value}
                          >
                            {label}
                          </Option>
                        ))}
                      </Select>)}
                  </div>
                </Form.Item>

              </Col>
            )}

            {this.props.drugTransferBalanceDrugs && (
              <Col span={12}>
                <b>
                  {this.props.i18n.t(
                    "NamespaceDrugShipForm:Overwrite Drug balancing"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator(`overwrite_balancing_drugs_shipment`)(
                    <Select placeholder={this.props.i18n.t("Select")}>
                      <Option value="balancing_within_shipment">
                        {this.props.i18n.t("NamespaceDrugShipForm:Balance within shipment only")}{" "}
                      </Option>
                      <Option
                        disabled
                        value="balancing_availability_destination"
                      >
                        {this.props.i18n.t("N/A")}
                      </Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>
            )}
            {/* <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Total active drug:")}{" "}</b>
                <Form.Item>
                  {getFieldDecorator('total_active_drug', {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: 10
                  })(
                    <Input />
                  )}
                </Form.Item>
              </label>
            </Col> */}
          </Row>

          {currentStep === 1 && (
            <Row gutter={12}>
              {/*{drugTransferList.length !== 0 && <Col span={24}>
              <div>
                <b>{this.props.i18n.t("Select drugs:")}{" "}</b>
                <Form.Item>
                  {getFieldDecorator('drug_ids', {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }]
                  })(
                    <Transfer
                      dataSource={drugTransferList}
                      targetKeys={drugTransferTargetKeys}
                      onChange={this.handleTransferChange('drugTransferTargetKeys')}
                      showSearch
                      render={item => item.title}
                      listStyle={{
                        height: 250,
                      }}
                    />
                  )}
                </Form.Item>
              </div>
            </Col>}*/}

              <Col span={24}>
                <div style={{ paddingBottom: "4px" }}>
                  <label>
                    <Checkbox
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState(() => ({
                            drugTransferTargetKeys: drugTransferList.map(
                              ({ key }) => key
                            ),
                          }));
                        } else {
                          this.setState(() => ({
                            drugTransferTargetKeys: [],
                          }));
                        }
                      }}
                    />
                    &nbsp; {this.props.i18n.t("Check all")} &nbsp; (
                    {drugTransferTargetKeys.length}/{drugTransferList.length})
                  </label>
                </div>

                {drugTransferList.map(({ key, title }, i) => (
                  <div key={key} style={{ paddingBottom: "4px" }}>
                    <label>
                      <Checkbox
                        checked={
                          drugTransferTargetKeys.findIndex(
                            (targetKey) => targetKey === key
                          ) > -1
                        }
                        onChange={this.onTargetKeyChange(i, key)}
                      />
                      &nbsp;
                      {title}
                    </label>
                  </div>
                ))}
                <br />
              </Col>
            </Row>
          )}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {currentStep !== 2 && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                  disabled={
                    currentStep === 1 && drugTransferTargetKeys.length === 0
                  }
                >
                  {currentStep === 0
                    ? this.props.i18n.t("Next")
                    : this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}
            {currentStep === 2 && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="button"
                  className={classes.submitButton}
                  onClick={this.onDrugPrintRequest(drug_transfer_list)}
                >
                  {this.props.i18n.t(
                    "NamespaceDrugShipForm:Print packing slip"
                  )}
                </Button>
                &nbsp; &nbsp;
                <Button
                  type="default"
                  size="large"
                  htmlType="button"
                  className={classes.submitButton}
                  onClick={this.props.onDrugShitClose}
                >
                  {this.props.i18n.t("Close")}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  drugShipmentAmount: getDrugShipmentAmount(state),
  drugAllowTransferFromFridgeToPatient: getDrugAllowTransferFromFridgeToPatient(
    state
  ),
  drugTransferBalanceDrugs: getDrugTransferBalanceDrugs(state),
  drugChooseOrderByPermission: getDrugChooseOrderByPermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "drugShip" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(DrugShipForm))
);



// WEBPACK FOOTER //
// ./src/components/DrugShipForm/DrugShipForm.js